var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPaymentGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 179,
    viewBox: "0 0 228 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.634 148.578H167.406V147.06H175.634C177.501 147.06 179.324 146.733 181.055 146.086L181.585 147.508C179.685 148.217 177.682 148.578 175.634 148.578ZM159.18 148.578H150.953V147.06H159.18V148.578ZM142.725 148.578H134.498V147.06H142.725V148.578ZM126.272 148.578H118.045V147.06H126.272V148.578ZM109.817 148.578H101.591V147.06H109.817V148.578ZM93.3626 148.578H85.1366V147.06H93.3626V148.578ZM76.9092 148.578H68.6819V147.06H76.9092V148.578ZM60.4558 148.578H52.2285V147.06H60.4558V148.578ZM44.0011 148.578H35.7738V147.06H44.0011V148.578ZM27.5477 148.578H19.3204V147.06H27.5477V148.578ZM10.9684 147.268C8.31919 146.162 5.97211 144.383 4.18032 142.123L5.36911 141.18C7.00186 143.238 9.13953 144.859 11.5529 145.867L10.9684 147.267V147.268ZM188.567 142.628L187.414 141.64C189.125 139.645 190.307 137.236 190.831 134.675L192.318 134.98C191.742 137.794 190.445 140.438 188.567 142.628ZM0.726635 134.337C0.575553 133.419 0.498692 132.481 0.500017 131.548V126H2.01746V131.549C2.01746 132.4 2.08637 133.255 2.2242 134.091L0.726635 134.337ZM192.663 126.626H191.146V118.398H192.663V126.626ZM2.01746 117.773H0.500017V109.547H2.01746V117.773ZM192.663 110.171H191.146V101.945H192.663V110.171ZM2.01746 101.318H0.500017V93.0906H2.01746V101.318ZM192.663 93.7161H191.146V85.4901H192.663V93.7161ZM2.01746 84.8645H0.500017V76.6372H2.01746V84.8645ZM192.663 77.2627H191.146V69.0367H192.663V77.2627ZM2.01746 68.4098H0.500017V60.1824H2.01746V68.4098ZM192.663 60.8093H191.146V52.5819H192.663V60.8093ZM2.01746 51.9564H0.500017V43.729H2.01746V51.9564ZM192.663 44.3546H191.146V36.1272H192.663V44.3546ZM2.01746 35.5017H0.500017V27.2757H2.01746V35.5017ZM192.663 27.9012H191.146V19.6738H192.663V27.9012ZM2.01746 19.0483H0.500017V17.0312C0.500017 14.8392 0.910849 12.7055 1.7206 10.6884L3.12937 11.2543C2.39119 13.0911 2.01746 15.034 2.01746 17.0312V19.0483ZM190.246 11.8123C189.367 9.34987 187.861 7.13002 185.889 5.39125L186.892 4.25283C189.056 6.16124 190.71 8.59844 191.675 11.302L190.246 11.8123ZM7.72944 5.00427L6.76993 3.82874C9.00303 2.00515 11.6788 0.773965 14.5069 0.267707L14.7746 1.7613C12.2009 2.2225 9.76375 3.34369 7.73076 5.00427H7.72944ZM178.973 1.87793C177.884 1.63805 176.76 1.51745 175.632 1.51745H170.937V0H175.632C176.869 0 178.101 0.132528 179.298 0.39626L178.973 1.87793ZM162.711 1.51745H154.483V0H162.711V1.51745ZM146.257 1.51745H138.03V0H146.257V1.51745ZM129.804 1.51745H121.577V0H129.804V1.51745ZM113.349 1.51745H105.123V0H113.349V1.51745ZM96.8945 1.51745H88.6685V0H96.8945V1.51745ZM80.4411 1.51745H72.2151V0H80.4411V1.51745ZM63.9864 1.51745H55.759V0H63.9864V1.51745ZM47.533 1.51745H39.3056V0H47.533V1.51745ZM31.0796 1.51745H22.8522V0H31.0796V1.51745Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.775 14.4834H21.8226C18.1088 14.4834 15.0981 17.4941 15.0981 21.2079V171.601C15.0981 175.315 18.1088 178.326 21.8226 178.326H220.775C224.489 178.326 227.5 175.315 227.5 171.601V21.2079C227.5 17.4941 224.489 14.4834 220.775 14.4834Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3531 41.6943H31.394V161.397H56.3531V41.6943Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1013 80.6182H72.3726V162.533H93.1013V80.6182Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.663 95.918H110.935V162.532H131.663V95.918Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.226 106.71H149.498V162.531H170.226V106.71Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.79 133.23H180.831V162.119H205.79V133.23Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.718 37.0703H69.8799V45.9828H172.718V37.0703Z",
    fill: "#00A657",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPaymentGraph);
export default __webpack_public_path__ + "static/media/no-payment-graph.a03a1c81f94184523d3f10711e6b853e.svg";
export { ForwardRef as ReactComponent };